import * as React from 'react'

import type { TabType } from 'modules/core/components/Table/Tabs/types'

interface Props<TabIds> {
  tab: TabType<TabIds>
  isSelected: boolean
  // FIXME will change when we come up with a new solution for modifying common components
  borderTop?: boolean
}

function TabPanel<TabIds>(props: React.PropsWithChildren<Props<TabIds>>) {
  const { tab, isSelected, children, borderTop } = props

  return (
    <div
      tabIndex={0}
      role="tabpanel"
      hidden={!isSelected}
      aria-labelledby={`${tab.id}-tab`}
      id={`${tab.id}-panel`}
      style={{
        outline: 'none',
        ...(borderTop && {
          borderTop: '1px solid #E5E7EB', // grey400 equivalent
          width: '100%',
        }),
      }}
    >
      {children}
    </div>
  )
}

export default TabPanel
